export enum BikeCellularConnectionType {
    GSM = 1,
    CAT_M1 = 2
}